import React, { FC } from 'react'

type IconProps = {
  className?: string
}

export const StarIcon: FC<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={'32'}
      viewBox={'0 0 40 40'}
      width={'32'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M19.9687 3.98535C20.5937 3.98535 21.0937 4.36035 21.3437 4.86035L25.6562 13.6729L35.2187 15.1104C35.7812 15.1729 36.2187 15.5479 36.4062 16.1104C36.5937 16.6729 36.4687 17.2354 36.0312 17.6729L29.0937 24.5479L30.7187 34.2354C30.8437 34.7979 30.5937 35.4229 30.1562 35.7354C29.6562 36.0479 29.0312 36.1104 28.5312 35.8604L19.9687 31.2354L11.4687 35.8604C10.9062 36.1104 10.3437 36.0479 9.84365 35.7354C9.40615 35.3604 9.15615 34.7979 9.28115 34.2354L10.9062 24.5479L3.96865 17.6729C3.53115 17.2354 3.40615 16.6729 3.59365 16.1104C3.78115 15.6104 4.21865 15.1729 4.78115 15.1104L14.3437 13.6729L18.6562 4.86035C18.9062 4.36035 19.4062 3.98535 19.9687 3.98535ZM19.9687 8.92285L16.7187 15.7354C16.4687 16.1729 16.0937 16.4854 15.5937 16.5479L8.21865 17.6104L13.5312 22.9229C13.9062 23.2979 14.0937 23.7979 13.9687 24.2354L12.7187 31.7354L19.2812 28.2354C19.7187 27.9854 20.2812 27.9854 20.7187 28.2354L27.2812 31.7354L26.0312 24.2979C25.9062 23.7979 26.0937 23.2979 26.4687 22.9854L31.7812 17.6104L24.4062 16.5479C23.9062 16.4854 23.5312 16.1729 23.2812 15.7354L19.9687 8.92285Z'
        }
        fill={'#141414'}
      />
    </svg>
  )
}
